import React, { ReactNode } from 'react';

import { CategoriesMobileDisplayOption } from 'types/graphql';
import { CategoriesCarousel } from 'src/components/carousel-v2/types/categories-carousel';
import { Grid, SliderContainer, ViewAllButton, GridContainer, GridHeading } from './list.styles';

type ListProps = {
  children: ReactNode;
  mobileDisplay: CategoriesMobileDisplayOption;
  enableViewAll?: boolean;
  isExpanded?: boolean;
  viewAllItems?: () => void;
};

export const List = ({
  children,
  mobileDisplay,
  enableViewAll = true,
  isExpanded,
  viewAllItems,
}: ListProps): JSX.Element => {
  const isMobileGrid = mobileDisplay === CategoriesMobileDisplayOption.grid;

  const heading = 'Categories';

  return (
    <>
      {isMobileGrid && (
        <GridContainer>
          <GridHeading data-testid='categories-carousel-heading'>{heading}</GridHeading>
          <Grid>{children}</Grid>
          {enableViewAll && !isExpanded && <ViewAllButton onClick={viewAllItems}>View All</ViewAllButton>}
        </GridContainer>
      )}

      <SliderContainer $isMobileGrid={isMobileGrid}>
        <CategoriesCarousel title={heading}>{children}</CategoriesCarousel>
      </SliderContainer>
    </>
  );
};
